import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Tabs.module.css';
import Skeleton from '../../../Skeleton/Skeleton';

const Tabs = ({ tabs, active, setActive, RouterLink, setRef, segmented, fullWidth } = {}) => {
  const bindClasses = classNameBind.bind(styles);
  const handleLinkClick = tab => () => { setActive(tab.value); };

  const renderLink = (tab) => {
    const baseClassName = segmented ? 'segment' : 'link';

    return RouterLink !== null
      ? (
        <RouterLink
          id={tab.id}
          to={tab.value}
          className={bindClasses(baseClassName, { 'full-width': fullWidth })}
          activeClassName={bindClasses('active')}
        >
          {tab.label}
        </RouterLink>
      )
      : (
        <button
          id={tab.id}
          type="button"
          className={bindClasses(baseClassName, { active: active === tab.value, 'full-width': fullWidth })}
          onClick={handleLinkClick(tab)}
        >
          {tab.label}
          {tab.isLoading && (
          <span className={bindClasses('loading-container')}>
            <Skeleton width={30} height={10} />
          </span>
          )}
        </button>
      );
  };

  return (
    <div
      className={bindClasses('tabs')}
      ref={setRef}
      data-ppuc-id="Tabs"
    >
      {tabs.map(tab => (
        <React.Fragment key={tab.id}>
          {renderLink(tab, RouterLink)}
        </React.Fragment>
      ))}
    </div>
  );
};

Tabs.defaultProps = {
  active: null,
  fullWidth: false,
  RouterLink: null,
  segmented: false,
  setActive: () => {},
  setRef: null,
};

export default Tabs;
